export default function renderIcon({
  width = "20",
  height = "20",
  color = "#21A526",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_56_20139)">
        <circle cx="27" cy="27" r="18.5625" fill="white" />
        <path
          d="M27 0C12.1116 0 0 12.1116 0 27C0 41.8884 12.1116 54 27 54C41.8884 54 54 41.8884 54 27C54 12.1116 41.8884 0 27 0ZM40.6846 21.2783L26.0594 35.903C25.6207 36.3418 25.0447 36.5626 24.4688 36.5626C23.8928 36.5626 23.3168 36.3418 22.8781 35.903L15.5657 28.5907C14.6857 27.7111 14.6857 26.2889 15.5657 25.4093C16.4453 24.5293 17.8671 24.5293 18.7471 25.4093L24.4688 31.131L37.5032 18.097C38.3828 17.2169 39.8046 17.2169 40.6846 18.097C41.5642 18.9765 41.5642 20.3983 40.6846 21.2783Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
